import usePermittedQuery from '_api/queries/usePermittedQuery';
import { Patient } from '_api/types';
import { ACCOUNT_TYPE } from '_constants';

import { UseGetAllPageSizeWithAlertProps } from '../types';

export const GET_ACTIVE_PATIENTS_KEY = 'get-active-patients';

export const useGetActivePatients = ({
  page = 0,
  size = 10,
  withAlerts = true,
}: UseGetAllPageSizeWithAlertProps) => {
  return usePermittedQuery<Patient[]>(
    [
      ACCOUNT_TYPE.ADMIN,
      ACCOUNT_TYPE.ORG_ADMIN,
      ACCOUNT_TYPE.HOS_ADMIN,
      ACCOUNT_TYPE.THERAPIST,
    ],
    () => `/patient/active?page=${page}&size=${size}&withAlerts=${withAlerts}`,
    {},
    [GET_ACTIVE_PATIENTS_KEY, withAlerts],
    {
      enabled: typeof page === 'number' && page >= 0,
      refetchOnWindowFocus: false,
    },
  );
};
